import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { DashboardTeamProvider } from '../../../context/DashboardTeamContext'
import DashboardTeamHome from './start/DashboardTeamHome'
import SalesMaterial from './material/SalesMaterial'
import DashboardFooter from '../DashboardFooter'
import DashboardTeam from './DashboardTeam';

interface DashboardTeamLayoutProps {
  match: {
    params: {
      association: string
      team: string
    }
  }
}

const DashboardTeamLayout: React.FC<DashboardTeamLayoutProps> = ({ match }) => {
  const { association, team } = match.params

  return (
    <DashboardTeamProvider associationId={association} teamId={team}>
      <Switch>
        <Route
          path="/cities/associations/:association/teams/:team/home"
          exact
          component={DashboardTeamHome}
        />
        <Route
          path="/cities/associations/:association/teams/:team/sales"
          exact
          component={DashboardTeam}
        />
        <Route
          path="/cities/associations/:association/teams/:team/help"
          exact
          component={SalesMaterial}
        />
      </Switch>
      <DashboardFooter />
    </DashboardTeamProvider>
  )
}

export default DashboardTeamLayout
